module.exports = __webpack_public_path__ + "img/esel.51583da0.png";